<template>
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-WoShi`]" width="1em" height="1em" v-bind="$attrs"><path d="M2.20312 12.375V5.25C2.20312 4.42157 2.8747 3.75 3.70312 3.75H20.2999C21.1283 3.75 21.7999 4.42157 21.7999 5.25V12.375" stroke="#333"/><path d="M5.10547 10.125V8.625C5.10547 7.79655 5.77704 7.125 6.60547 7.125H10.5006C11.3291 7.125 12.0006 7.79655 12.0006 8.625V9.75M18.8971 10.125V8.625C18.8971 7.79655 18.2255 7.125 17.3971 7.125H13.502C12.6735 7.125 12.002 7.79655 12.002 8.625V9.75" stroke="#333"/><path d="M3.57823 19.5H0.825C0.783578 19.5 0.75 19.4664 0.75 19.425V16.5C0.75 12.772 3.77208 9.75 7.5 9.75H16.5C20.228 9.75 23.25 12.772 23.25 16.5V19.425C23.25 19.4664 23.2164 19.5 23.175 19.5H20.4218C20.3804 19.5 20.3467 19.4664 20.3467 19.425V18.75C20.3467 17.9216 19.6752 17.25 18.8467 17.25H5.15323C4.3248 17.25 3.65323 17.9216 3.65323 18.75V19.425C3.65323 19.4664 3.61965 19.5 3.57823 19.5Z" stroke="#333"/></svg>
</template>
<script>

export default {
  name: 'IconWoShi',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
